import { createStateContext } from '@change-corgi/core/react/context';

import { INITIAL_STATE } from './initialState';
import { mutations } from './mutations';
import type { DecisionMakerResponsePageState } from './types';

export const {
	StateContext: DecisionMakerResponsePageStateContext,
	StateProvider: DecisionMakerResponsePageStateContextProvider,
	useStateContext: useDecisionMakerResponsePageState,
} = createStateContext<DecisionMakerResponsePageState, typeof mutations>({
	name: 'DecisionMakerResponsePageStateContext',
	mutations,
	initialState: INITIAL_STATE,
});
